import React, { forwardRef, HTMLAttributes } from 'react';
import type { StoryModel } from 'types/story';
import useImage from 'common/components/useImage';
import Loader from 'common/components/Loader';

type Props = {
	src: string;
	lowQualitySrc?: string;
	alt?: string;
	storycardsDomain: StoryModel['storycardsDomain'];
} & HTMLAttributes<HTMLImageElement>;

const ImageLoadable = forwardRef<HTMLImageElement, Props>(
	({ src, alt = '', storycardsDomain, lowQualitySrc, ...props }: Props, ref) => {
		const image = useImage(src);

		// show fully loaded image
		if (image.loaded) {
			return <img {...props} src={src} alt={alt} ref={ref} draggable={false} />;
		}

		if (lowQualitySrc) {
			return <img {...props} src={lowQualitySrc} alt={alt} ref={ref} draggable={false} />;
		}

		// render loader
		return <Loader color="black" fullFrame bgColor="rgba(255, 255, 255, 0.18)" />;
	}
);

export default React.memo(ImageLoadable);
